<template>
  <div class="orderBox">
    <div class="form-title">投保人</div>
    <person :formData="formData" :formKey="formKey" :disabled="disabled"></person>
    <detail :formData="formData" :formKey="formKey" :disabled="disabled"></detail>
  </div>
</template>

<script>
import person from "./person";
import detail from "./detail";
export default {
  components: { person, detail },
  props: {
    disabled: {},
    formData: {
      default() {
        return {};
      }
    },
    formKey: {}
  },
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  created() {
  },
  mounted() { },
  methods: {
  }
};
</script>
<style lang="scss" scoped></style>
